<div class="data-capture-shell flex flex-row" [class.fullscreen]="isFullscreen">
  <div class="data-capture-group" [class.viewing-citation]="viewingCitation">
    @if (loading || deletingSheet) {
      <div class="sheet-container">
        <div class="sheet-area">
          <app-loader></app-loader>
        </div>
      </div>
    }

    @if (!loading && !deletingSheet) {
      <div class="sheet-container" data-test-id="data-capture-sheet-container">
        <div class="sheet-area">
          @if (!availableSheets.length) {
            <div class="flex flex-col items-center justify-between w-full">
              <div
                class="flex flex-col items-center justify-center gap-16 m-auto"
              >
                <div class="content-center justify-center items-center">
                  <h2 data-test-id="data-capture-set-up-data-capture-title">
                    Set up your Data Capture in 5 easy steps
                  </h2>
                  <div class="flex items-center justify-center">
                    <button
                      mat-flat-button
                      color="primary"
                      data-test-id="data-capture-set-up-data-capture-button"
                      (click)="newSheet()"
                    >
                      Get started
                    </button>
                  </div>
                </div>
              </div>
              <a
                class="help-link"
                href="https://techspert.com/hubfs/Techspert%20Data%20Capture%20-%20How-To%20Guide.pdf"
                target="_blank"
                rel="noopener noreferrer"
              >
                See the how-to guide for assistance setting up your Data
                Capture.
              </a>
            </div>
          }
          @if (selectedSheet) {
            <app-data-sheet
              [dataCaptureSheetId]="selectedSheet.data_capture_sheet_id"
              [sheet]="selectedSheet.discussion_guide"
              [sheetHeaders]="selectedSheet.additional_export_headers"
              [answer_format]="selectedSheet.answer_format"
              [refreshDataTrigger]="true"
              [answerClickThrough]="true"
              [respondentClickThrough]="true"
              (openCitation)="openCitation($event)"
              (sheetUpdated)="handleSheetUpdated($event)"
            ></app-data-sheet>
          }
        </div>
        <div class="sheet-selection flex items-center">
          @if (availableSheets.length) {
            @for (sheet of availableSheets; track sheet) {
              <div
                class="sheet"
                data-test-id="data-capture-sheet-tabs"
                [class.selected]="
                  selectedSheet &&
                  selectedSheet.data_capture_sheet_id ===
                    sheet.data_capture_sheet_id
                "
                (click)="selectSheet(sheet)"
              >
                <b class="sheet-name" [matTooltip]="sheet.name">{{
                  sheet.name
                }}</b>
                <mat-icon
                  data-test-id="data-capture-sheet-tab-options"
                  [matMenuTriggerFor]="menu"
                  (click)="$event.stopPropagation()"
                  >more_vert</mat-icon
                >
                <mat-menu #menu="matMenu">
                  <button
                    mat-menu-item
                    data-test-id="data-capture-edit-sheet-button"
                    (click)="edit(sheet)"
                  >
                    <mat-icon>edit</mat-icon>
                    <span>Edit</span>
                  </button>
                  <button
                    mat-menu-item
                    data-test-id="data-capture-duplicate-sheet-button"
                    (click)="duplicateSheet(sheet)"
                  >
                    <mat-icon>content_copy</mat-icon>
                    <span>Duplicate</span>
                  </button>
                  <button
                    mat-menu-item
                    data-test-id="data-capture-download-sheet-button"
                    (click)="downloadCsv(sheet)"
                  >
                    <mat-icon>download</mat-icon>
                    <span>Download</span>
                  </button>
                  <button
                    mat-menu-item
                    data-test-id="data-capture-delete-sheet-button"
                    (click)="deleteSheet(sheet)"
                  >
                    <mat-icon>delete</mat-icon>
                    <span>Delete</span>
                  </button>
                </mat-menu>
              </div>
            }
            <div
              class="sheet add"
              data-test-id="data-capture-add-extra-sheet"
              (click)="newSheet()"
            >
              <b>+</b>
            </div>
          } @else {
            <div
              class="sheet add"
              data-test-id="data-capture-add-initial-sheet"
            >
              <b>Get started</b>
            </div>
          }
          <div class="button-action-container flex gap-2 items-center">
            <button
              mat-stroked-button
              color="primary"
              data-test-id="data-capture-add-expert-button"
              [disabled]="loading"
              (click)="addRespondent()"
            >
              <mat-icon>person_add</mat-icon>
              Add expert
            </button>
            <button
              mat-flat-button
              color="primary"
              data-test-id="data-capture-download-sheet-button"
              [disabled]="loading || downloadingCsv"
              (click)="downloadCsv()"
            >
              <mat-icon class="secondaryColor">download</mat-icon>
              Download
            </button>
            <button
              mat-stroked-button
              color="primary"
              data-test-id="data-capture-fullscreen-toggle"
              (click)="toggleFullscreen()"
            >
              <mat-icon>{{
                isFullscreen ? 'fullscreen_exit' : 'fullscreen'
              }}</mat-icon>
              {{ isFullscreen ? 'Exit full screen' : 'Full screen' }}
            </button>
          </div>
        </div>
      </div>
    }

    <span class="disclaimer" data-test-id="data-capture-footer-text">
      Responses are generated using AI - you are responsible for verifying
      accuracy.
    </span>
  </div>

  @if (viewingCitation) {
    <div class="transcript-container">
      <div class="top-container flex flex-row justify-between items-center">
        <h4>Reference</h4>
        <button mat-icon-button (click)="closeCitation()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
      @if (loadingCitation) {
        <div class="inner-container">
          <app-loader></app-loader>
        </div>
      } @else {
        <div class="inner-container">
          <app-transcription-playback
            [transcriptChunks]="transcriptChunks"
            [audioData]="audioData"
            [fileName]="transcriptFileName"
            [audioStartTime]="audioStartTime"
          ></app-transcription-playback>
        </div>
      }
    </div>
  }
</div>
